// src/components/organisms/Profile/ProfileSubmissionsSection.js

import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import SubmissionCard from "../../molecules/ChallengeSubmission/SubmissionCard";

const ProfileSubmissionsSection = ({ profileId, firstName, submissions, theme }) => {

  return (
    <Box
      sx={{
        backgroundColor: theme.colors.lightBlue,
        borderRadius: "25px",
        padding: 4,
        paddingBottom: 0,
        mt: 4, // Add margin-top for spacing
      }}
    >
      {/* Full-width Row Above the Grid */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 4,
        }}
      >
        {/* Blue Circle */}
        <Box
          sx={{
            width: 20,
            height: 20,
            backgroundColor: theme.colors.red,
            borderRadius: "50%",
            marginRight: 2,
          }}
        ></Box>

        {/* Vertical Line */}
        <Box
          sx={{
            width: 2,
            height: 40,
            backgroundColor: theme.colors.darkGray,
            marginRight: 2,
          }}
        ></Box>

        {/* User's First Name and Link */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "basic-sans",
              fontWeight: "normal",
              marginRight: 2,
              fontSize: "1.2em",
            }}
          >
            {firstName}'s Submissions
          </Typography>
        </Box>
      </Box>

      {/* Grid of Submission Cards */}
      <Grid container spacing={4}>
        {submissions.map((submission) => (
          <Grid item xs={12} sm={6} md={4} key={submission.id}>
            <SubmissionCard submission={submission} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProfileSubmissionsSection;
